/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Interval_WeeklyInputs */

const en_plan_interval_weekly = /** @type {(inputs: Plan_Interval_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly`)
};

const es_plan_interval_weekly = /** @type {(inputs: Plan_Interval_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanal`)
};

/**
* | output |
* | --- |
* | "Weekly" |
*
* @param {Plan_Interval_WeeklyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_weekly = /** @type {((inputs?: Plan_Interval_WeeklyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_WeeklyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_weekly(inputs)
	return en_plan_interval_weekly(inputs)
});